(function(){
var $=function(s,r){return (r||document).querySelector(s)},$$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))};
var fmt=function(c){return new Intl.NumberFormat('en-IN',{style:'currency',currency:(window.BP&&BP.currency)||'INR',maximumFractionDigits:0}).format(c/100)};
function toast(m){var t=$('.bp-toast');if(!t){t=document.createElement('div');t.className='bp-toast';document.body.appendChild(t)}t.innerHTML=m+' <a href="/cart">View bag</a>';t.classList.add('is-on');clearTimeout(t._t);t._t=setTimeout(function(){t.classList.remove('is-on')},3400)}
function refresh(){return fetch('/cart.js').then(function(r){return r.json()}).then(function(c){$$('[data-bp-count]').forEach(function(e){e.textContent=c.item_count;e.hidden=!c.item_count})})}
var WU={g:'g',kg:'kg',lb:'lb',oz:'oz'};
var st=document.createElement('style');
st.textContent=`.bp-dl{margin:0 0 26px;display:grid;gap:0}.bp-dl div{display:flex;justify-content:space-between;gap:20px;padding:12px 0;border-top:1px solid rgba(0,0,0,.1);font:300 15px/1.4 var(--bp-body)}.bp-dl div:first-child{border-top:0}.bp-dl dt{color:rgba(0,0,0,.6)}.bp-dl dd{margin:0;text-align:right;color:#000;word-break:break-word}
.bp-stick select[data-optsel]{-webkit-appearance:none;-moz-appearance:none;appearance:none;flex:none;height:46px;width:230px;min-width:0;margin:0;padding:0 48px 0 20px;border:1px solid rgba(0,0,0,.25);border-radius:999px;background-color:#fff;background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23000' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E");background-repeat:no-repeat;background-position:right 18px center;background-size:16px 16px;color:#000;font:500 14px/1 var(--bp-body);text-overflow:ellipsis;white-space:nowrap;cursor:pointer;transition:border-color .2s}
.bp-stick select[data-optsel]:hover,.bp-stick select[data-optsel]:focus{border-color:#000;outline:0}
.bp-stick select[data-optsel]:focus-visible{outline:2px solid #000;outline-offset:2px}
.bp-stick select[data-optsel] option{font:400 14px var(--bp-body);color:#000;background:#fff}
.bp-gal__track [data-media][hidden],.bp-th[hidden],.bp-gal__dots i[hidden],.bp-thumbs-w[hidden],.bp-gal__dots[hidden],.bp-gal__cnt[hidden]{display:none!important}`;
document.head.appendChild(st);
/* gg Variant Images app: per-variant media assignments (rendered by the app embed) */
var gg=(function(){
 var el=document.getElementById('variant-image-assignments');if(!el)return null;
 var A;try{A=JSON.parse(el.textContent)}catch(e){return null}
 var last=function(x){return String(x).split('/').pop()},vm={},cfg={},com={},any=false;
 (A.commonMediaIds||[]).forEach(function(x){com[last(x)]=1});
 if(A.variantMediaIndex)Object.keys(A.variantMediaIndex).forEach(function(k){var l=A.variantMediaIndex[k];if(l&&l.length){any=true;vm[last(k)]=l.map(last)}});
 if(!any&&A.assignmentsByOption)Object.keys(A.assignmentsByOption).forEach(function(o){A.assignmentsByOption[o].forEach(function(e){var ids=(e.mediaIds||[]).map(last);if(!ids.length)return;(e.variantIds||[]).forEach(function(v){v=last(v);var c=vm[v]||(vm[v]=[]);ids.forEach(function(i){if(c.indexOf(i)<0)c.push(i)})})})});
 if(A.assignedMediaIds&&A.assignedMediaIds.length)A.assignedMediaIds.forEach(function(x){cfg[last(x)]=1});else Object.keys(vm).forEach(function(k){vm[k].forEach(function(m){cfg[m]=1})});
 return Object.keys(vm).length?{vm:vm,cfg:cfg,com:com}:null;
})();
$$('[data-bp-pdp]').forEach(function(root){
 var V=JSON.parse($('[data-variants]',root).textContent).variants,idIn=$('[name=id]',root),ins=$$('[data-qty]',root),sels=$$('[data-optsel]',root),stick=$('.bp-stick',root);
 var track=$('.bp-gal__track',root),tbox=$('.bp-thumbs',root),twrap=$('.bp-thumbs-w',root),cnt=$('.bp-gal__cnt',root),dotsBox=$('.bp-gal__dots',root);
 var orig=track?$$('[data-media]',track).map(function(d){return d.getAttribute('data-media')}):[],lastId=null;
 function vis(){return track?$$('[data-media]:not([hidden])',track):[]}
 function mark(){
  if(!track)return;
  var vs=vis(),i=Math.max(0,Math.min(vs.length-1,Math.round(track.scrollLeft/(track.clientWidth||1)))),id=vs[i]&&vs[i].getAttribute('data-media');
  $$('.bp-gal__dots i',root).forEach(function(d,j){d.classList.toggle('is-on',j===i)});
  if(cnt)cnt.textContent=(i+1)+'/'+vs.length;
  $$('[data-th]',root).forEach(function(b){b.classList.toggle('is-on',b.getAttribute('data-th')===id)});
  var on=tbox&&tbox.querySelector('.is-on');
  if(on&&tbox.scrollWidth>tbox.clientWidth)tbox.scrollTo({left:on.offsetLeft-tbox.clientWidth/2+on.offsetWidth/2,behavior:'smooth'});
 }
 function gallery(id){
  if(!track)return;
  var list=gg&&gg.vm[id]?gg.vm[id].filter(function(m){return orig.indexOf(m)>-1}):null;
  if(list&&!list.length)list=null;
  var seq=list?list.concat(orig.filter(function(m){return list.indexOf(m)<0})):orig.slice(),n=0;
  seq.forEach(function(m){
   var s=track.querySelector('[data-media="'+m+'"]'),t=tbox&&tbox.querySelector('[data-th="'+m+'"]'),on=!list||!gg.cfg[m]||list.indexOf(m)>-1||!!gg.com[m];
   if(s){track.appendChild(s);s.hidden=!on}
   if(t){tbox.appendChild(t);t.hidden=!on}
   if(on)n++;
  });
  var dots=$$('.bp-gal__dots i',root);dots.forEach(function(d,j){d.hidden=j>=n});
  if(dotsBox)dotsBox.hidden=n<2;if(cnt)cnt.hidden=n<2;if(twrap)twrap.hidden=n<2;
  track.style.scrollBehavior='auto';track.scrollLeft=0;track.style.scrollBehavior='';
  var im=$('.bp-stick>img',root),t0=tbox&&tbox.querySelector('[data-th]:not([hidden]) img');if(im&&t0)im.src=t0.src;
  mark();
 }
 if(track)track.addEventListener('scroll',mark,{passive:true});
 function qty(){return Math.max(1,Math.min(99,parseInt(ins[0]&&ins[0].value,10)||1))}
 function cur(){return V.filter(function(v){return String(v.id)===String(idIn.value)})[0]}
 function sync(){
  var v=cur(),q=qty();
  ins.forEach(function(i){i.value=q});
  if(v){
   $$('[data-subtotal]',root).forEach(function(e){e.textContent=fmt(v.price*q)});
   $$('[data-saved]',root).forEach(function(e){var s=v.compare-v.price;e.hidden=!(s>0);e.textContent=s>0?'Saved '+fmt(s):''});
   $$('[data-weight]',root).forEach(function(e){if(v.weight>0)e.textContent=(+v.weight.toFixed(2))+' '+(WU[v.wunit]||v.wunit)});
   $$('[data-sku]',root).forEach(function(e){if(v.sku)e.textContent=v.sku});
   if(lastId!==v.id){lastId=v.id;gallery(String(v.id))}
  }
  sels.forEach(function(s){var b=$('[data-opt="'+s.getAttribute('data-optsel')+'"][aria-pressed=true]',root);if(b)s.value=b.getAttribute('data-val')});
 }
 root.addEventListener('click',function(e){
  if(e.target.closest('[data-opt]'))setTimeout(sync,30);
  var d=e.target.closest('[data-qd]'),u=e.target.closest('[data-qu]');
  if(d||u){ins.forEach(function(i){i.value=Math.max(1,Math.min(99,qty()+(u?1:-1)))});sync();return}
  var n=e.target.closest('[data-tn]');
  if(n){if(tbox)tbox.scrollBy({left:(n.getAttribute('data-tn')==='n'?1:-1)*tbox.clientWidth*.8,behavior:'smooth'});return}
  var th=e.target.closest('[data-th]');
  if(th&&track){var s=track.querySelector('[data-media="'+th.getAttribute('data-th')+'"]');if(s)track.scrollTo({left:s.offsetLeft,behavior:'smooth'})}
 });
 ins.forEach(function(i){i.addEventListener('change',sync)});
 sels.forEach(function(s){s.addEventListener('change',function(){var idx=s.getAttribute('data-optsel');$$('[data-opt="'+idx+'"]',root).forEach(function(b){if(b.getAttribute('data-val')===s.value)b.click()})})});
 root.addEventListener('click',function(e){
  var b=e.target.closest('[data-bp-atc],[data-bp-buy]');
  if(!b||!root.contains(b))return;
  e.stopPropagation();e.preventDefault();
  var v=cur();if(!v||b.disabled)return;
  var buy=b.hasAttribute('data-bp-buy');b.disabled=true;
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:v.id,quantity:qty()}]})})
   .then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j})})
   .then(function(){if(buy){
    // location.href='/checkout';
    if (window.gokwikSdk && typeof window.gokwikSdk.initCheckout === "function") {
     window.gokwikSdk.initCheckout(merchantInfo);
   } else {
     console.error("GoKwik SDK not ready");
   }
    return
  }
  toast('Added to bag');refresh()})
   .catch(function(x){toast((x&&x.description)||'Could not add')})
   .then(function(){b.disabled=false});
 },true);
 var mb=$('[data-main-buy]',root);
 if(stick&&mb&&'IntersectionObserver' in window){new IntersectionObserver(function(en){var x=en[0];stick.classList.toggle('is-on',!x.isIntersecting&&x.boundingClientRect.top<0)}).observe(mb)}
 setTimeout(sync,60);
});
})();